let headers = {};
export function setMobileAppInfo(info) {
    const next = {};
    if (info.version)
        next['X-App-Version'] = info.version;
    if (info.build)
        next['X-App-Build'] = info.build;
    if (info.platform)
        next['X-App-Platform'] = info.platform;
    headers = next;
}
export function getMobileAppHeaders() {
    return { ...headers };
}
